import { render, staticRenderFns } from "./PassengerDetailPanel.vue?vue&type=template&id=84937bb4&scoped=true&"
import script from "./PassengerDetailPanel.vue?vue&type=script&lang=js&"
export * from "./PassengerDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./PassengerDetailPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PassengerDetailPanel.vue?vue&type=style&index=1&id=84937bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84937bb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VList,VListItem,VListItemContent,VMenu,VSpacer,VToolbar})
